// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".USPs[data-v-63abb048]{line-height:1.2rem;list-style:none}.USPs .x-icon[data-v-63abb048]{font-size:1.1rem;height:1.4rem;margin-right:.5rem;margin-top:-.1rem;width:1.4rem}.USPs .title[data-v-63abb048]{color:#212528;font-size:1rem;font-weight:700}.USPs .description[data-v-63abb048]{font-size:.85rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
